export const en = {
  pay: 'Pay',
  requestStatus: 'Request status',
  successMessage: 'Notification sent successfully',
  successMessageDescription: 'Effective payment has been made and application No. {requestNumber} has been submitted ',
  failed: 'Failed to send notification',
  failedMessage: 'Payment process is incomplete, please check the payment process to complete the notification',
  failedMessageContactSupport: 'Or check with technical support with the following code',
  cancelled: 'Waiting for payment',
  canceledMessage: 'Payment has not been processed yet, you can try again',
  retrycheckout: 'retry',

  awaitingPaymentMessage: 'A payment invoice has been successfully created and your order status is now awaiting payment,',
  awaitingPayment: 'Awaiting payment',
  sadadBillExpired: 'Sadad bill has expired',
  sadadBillExpiredMessage: 'The bill number has been canceled due to the expiration of the payment period',
  sadadReferenceNumber: 'Sadad invoice number',
  shouldPaidBefore: 'Payment must be made before',
  copiedSuccessfully: 'Copied successfully',
  backToTechSupport: 'Back to Technical Support',
  backToHome: 'Back to Home',
  requestsList: 'Requests List',
  paymentInfo: 'Payment info',
  requestPreview: 'Request preview',
  referenceNumber: 'Reference number',
  paymentStatus: 'Payment status',
  paymentCompletedSuccessfully: 'Payment completed successfully',
  underProcessingMessage: 'The order will be submitted immediately after confirmation',
  underProcessing: 'Waiting for the payment gateway to confirm the transaction',
};
